const TRANSACTION_STATUS_LIST = [
  "Payment Completed",
  "Payment Failed",
  "Cart created",
  "HITL Pending",
  "HITL Reviewed",
  "Dispute Raised",
  "Dispute Approved",
  "Dispute Reviewed",
  "Dispute Declined",
  "Dispute Closed",
  "Refund Completed",
  "Refund Failed",
  "Chargeback Completed",
  "Chargeback Failed",
]
export const TRANSACTION_STATUS_PENDING_LIST = [
  "Cart created",
  "HITL Pending",
  "HITL Reviewed",
]
export const TRANSACTION_STATUS_POSITIVE_LIST = [
  "Payment Completed",
  "Dispute Raised",
  "Dispute Approved",
  "Dispute Reviewed",
  "Dispute Declined",
  "Dispute Closed",
]

export const getDefaultReceiptList = (response) => {
  console.log("response", response)

  let dataKit = response || [{}, {}]
  let cf = [
    {
      transaction_status: "HITL Reviewed",
      updated_local_datetime: "2026-02-12T16:45:43",
      updated_utc_datetime: "2026-02-12T12:45:43",
      created_local_datetime: "2026-02-12T16:31:03",
      created_utc_datetime: "2026-02-12T12:31:03",
    },
    ...[{ ...dataKit[0], transaction_status: "Payment Failed" }],
    {
      transaction_status: "HITL Pending",
      updated_local_datetime: "2026-02-12T16:45:43",
      updated_utc_datetime: "2026-02-12T12:45:43",
      created_local_datetime: "2026-02-12T16:31:03",
      created_utc_datetime: "2026-02-12T12:31:03",
    },
    ...dataKit,
    ...dataKit,
    ...dataKit,
    ...dataKit,
    {
      transaction_status: "HITL Reviewed",
      updated_local_datetime: "2026-02-12T16:45:43",
      updated_utc_datetime: "2026-02-12T12:45:43",
      created_local_datetime: "2026-02-12T16:31:03",
      created_utc_datetime: "2026-02-12T12:31:03",
    },
  ]

  cf = dataKit
  cf = cf?.map((txnItm, index = 0) => {
     let cartKit =
      // txnItm?.carts?.find((item) => item?.is_active === true) ||
      txnItm?.carts?.[0] ||
      {}
    const statusName = String(txnItm?.transaction_status || "").toLowerCase()
    const isReceiptPending = TRANSACTION_STATUS_PENDING_LIST.some(
      (status) => status.toLowerCase() === statusName
    )
    const isReceiptPositive = TRANSACTION_STATUS_POSITIVE_LIST.some(
      (status) => status.toLowerCase() === statusName
    )
    if (
      TRANSACTION_STATUS_LIST.some(
        (status) =>
          status.toLowerCase() ===
          (txnItm?.transaction_status || "").toLowerCase()
      )
    ) {
      return {
        ...txnItm,
        currencySymbol: txnItm?.store?.currency_details?.currency_symbol || "$",
        heading: "Thanks for visiting. Your receipt will be ready soon.",
        subHeading: "Save this page and check back shortly.",
        receiptPendingShow: isReceiptPending,
        receiptPositiveShow: isReceiptPositive,
        transactionTime: isReceiptPending
          ? txnItm?.created_local_datetime || ""
          : txnItm?.updated_local_datetime || "",
        receiptShow: true,
        receiptNo: "Receipt " + (index + 1),
        transactionId: txnItm?.transaction_id || "",
        storeInfo: `${txnItm?.store?.store_name || ""}, ${
          txnItm?.store?.address?.line1 || ""
        }, ${txnItm?.store?.address?.line2 || ""}`,
        dateInfo: `21/09/2025 10:25:32 PM`,
        customerText:
          "Thanks for shopping with us! We love keeping your checkout quick and simple. ",
        customerSubText: "Below are the details of your Purchase.",
        cartList: cartKit?.items?.map((cartItemKit) => {
          return {
            ...cartItemKit,
            productName: cartItemKit?.title || "",
            productPrice: cartItemKit?.line_item_offer_price_total || 0,
            quantity: cartItemKit?.quantity || 0,
            tax: cartItemKit?.line_item_tax_total || 0,
            Total: cartItemKit?.line_item_total_gross_amount || 0,
          }
        }),
        cartInfo: {
          totalItemPurchased: cartKit?.total_quantity || 0,
          totalGrand: cartKit?.total_gross_amount || 0,
        },
        companyInfo: {
          regard: "Digitmart",
          title:
            "For any billing disputes or inquiries, please contact us here",
          email: `${txnItm?.store?.store_support_email}`,
          phone: `${txnItm?.store?.phone_number?.country_code}${txnItm?.store?.phone_number?.number}`,
        },
      }
    } else {
      return {}
    }
  })

  return cf
}
